const radii = {
  base: "6px"
};

export default radii;
